import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { makeGetSeoLinksBlocksItems } from 'selectors';
import SeoLinksBlock from 'components/SeoLinksBlock';
var getSeoLinksBlocksItems = makeGetSeoLinksBlocksItems();

function SeoLinksBlocks(_ref) {
  var match = _ref.match,
      location = _ref.location;
  var intl = useIntl();
  var selectorProps = {
    intl: intl,
    match: match,
    location: location
  };
  var linksBlocksItems = useSelector(function (state) {
    return getSeoLinksBlocksItems(state, selectorProps);
  });
  return linksBlocksItems.map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        children = _ref2.children;
    return /*#__PURE__*/_jsx(SeoLinksBlock, {
      title: name,
      links: children
    }, id);
  });
}

export default withRouter(SeoLinksBlocks);